import "./home.scss"
import React from "react";

export const Home = function () {
    return (
        <div className={'home-page'}>
            Home123
        </div>
    )
}